import { useState, useEffect } from 'react'
import { supabase } from '../services/supabase'

// Lecteur de la table `modeles` (source unique des modèles de planches).
// Repli sur les 2 modèles actuels si la table ne répond pas → l'app marche toujours.
const FALLBACK = [
  { id: '10p6', label: "10'8\"", nom_complet: "Bluefin 10'8\"", capacite_kg: 150, sous_titre: 'Polyvalente — débutants, enfants & familles', description: 'Large et stable, c\'est la plus polyvalente. Parfaite pour débuter, pour les enfants et les familles qui veulent explorer en douceur les eaux calmes de la baie de Quiberon.', tag: 'Débutants & Familles', specs: "325 × 82 × 16 cm", photo_url: null, ordre: 1, actif: true },
  { id: '9p5',  label: "12'",    nom_complet: "Bluefin 12'",     capacite_kg: 175, sous_titre: 'Grande & rapide — balade et glisse',          description: 'Plus longue, elle glisse et tient le cap. Idéale pour les balades plus longues, les grands gabarits, ou pour emmener un enfant devant soi le long de la presqu\'île de Quiberon.',  tag: 'Rando & Glisse',       specs: "366 × 81 × 15 cm", photo_url: null, ordre: 2, actif: true },
]

export function useModeles() {
  const [modeles, setModeles] = useState(FALLBACK)
  useEffect(() => {
    let on = true
    supabase.from('modeles').select('*').eq('actif', true).order('ordre').then(({ data, error }) => {
      if (on && !error && Array.isArray(data) && data.length) setModeles(data)
    })
    return () => { on = false }
  }, [])
  return modeles
}
